import * as Types from "../actions/Types";

const INITIAL_STATE = {
  isCreating: false,
  errorCreating: false
};

export default (state = INITIAL_STATE, action) => {
  const { type } = action;
  switch (type) {
    case Types.SEND_ERROR_REPORT_EMAIL:
      return {
        ...state,
        isCreating: true,
        errorCreating: false
      };
    case Types.SEND_ERROR_REPORT_EMAIL_SUCCESSFUL:
      return {
        ...state,
        isCreating: false,
        errorCreating: false
      };
    case Types.SEND_ERROR_REPORT_EMAIL_FAILED:
      return {
        ...state,
        isCreating: false,
        errorCreating: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ErrorReport.js